export class localStorage {
  static setItem (key, value) {
    window.localStorage.setItem(key, value)
  }

  static setItemEncrypted (key, value) {
    window.localStorage.setItem(key, value)
  }

  static getItem (key) {
    return window.localStorage.getItem(key)
  }

  static getItemEncrypted (key) {
    return window.localStorage.getItem(key)
  }

  static removeItem (key) {
    return window.localStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/local-storage.js